import React from 'react';
import PropTypes from 'prop-types';
import DeliveryOptionsForm from '../_utils/_delivery-options/delivery-options-form';

const DeliveryOptions = (
  { selectedOption, options, itemId },
  { showDeliveryOptionSelectorsWithinItems = true }
) => {
  if (!showDeliveryOptionSelectorsWithinItems) {
    return null;
  }

  if (!options.length) {
    return (
      <span className="text-danger">
        No delivery option is available for this item. Please{' '}
        <strong>delete</strong> this item to proceed.
      </span>
    );
  }

  return (
    <div className="delivery-options-list">
      <DeliveryOptionsForm
        itemId={itemId}
        selectedOption={selectedOption}
        options={options}
        horizontalLayout
      />
    </div>
  );
};

DeliveryOptions.propTypes = {
  selectedOption: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number,
      type: PropTypes.string,
      timescale: PropTypes.string,
      time_hours: PropTypes.number,
      title: PropTypes.string,
      analytics_id: PropTypes.string,
      code: PropTypes.string,
    })
  ).isRequired,
};

DeliveryOptions.contextTypes = {
  showDeliveryOptionSelectorsWithinItems: PropTypes.bool,
};

export default DeliveryOptions;
